import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import {useComparisonInfoActions, usePullRequestBasePath} from '../stores/selectors'

export type UpdateWhitespacePreferenceMutationResponse = {
  ignoreWhitespace: boolean
}

export function useUpdateWhitespacePreferenceMutation() {
  const basePath = usePullRequestBasePath()
  const {updateWhitespace} = useComparisonInfoActions()

  return useMutation({
    mutationFn: async ({hideWhitespace}: {hideWhitespace: boolean}) => {
      const apiUrl = `${basePath}/page_data/${PageData.updateWhitespacePreference}`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          w: hideWhitespace ? 1 : 0,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UpdateWhitespacePreferenceMutationResponse) => {
      updateWhitespace(data.ignoreWhitespace)
    },
  })
}
